import { render, staticRenderFns } from "./wx-path.vue?vue&type=template&id=802ff058&scoped=true"
import script from "./wx-path.vue?vue&type=script&lang=js"
export * from "./wx-path.vue?vue&type=script&lang=js"
import style0 from "./wx-path.vue?vue&type=style&index=0&id=802ff058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802ff058",
  null
  
)

export default component.exports